import * as moment from "moment-timezone";

export const dateService = {
  getTimeZone: (): string => moment.tz.guess(),

  getTimeZoneAbbr: (): string => moment.tz(moment.tz.guess()).zoneAbbr(),

  localizeDate: (date: string, inFormat: string, outFormat: string): string => {
    return moment.utc(date, inFormat).tz(moment.tz.guess()).format(outFormat);
  },
};
